var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternetAccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71645 13.3446C8.33911 13.0805 8.99927 12.9313 9.68207 12.9016V10.3172L6.93127 10.318C7.00471 11.3704 7.26877 12.3868 7.71643 13.3446L7.71645 13.3446Z",
    fill: "#2E84FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91101 9.682H9.68281L9.68203 7.0968C8.93437 7.06399 8.21641 6.88976 7.54383 6.57648C7.12821 7.5468 6.91571 8.58968 6.91101 9.68188L6.91101 9.682Z",
    fill: "#2E84FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.311 5.1742C12.8985 4.89842 12.4578 4.67732 11.9938 4.51248C12.2688 4.86716 12.5141 5.2406 12.725 5.62966C12.9305 5.49294 13.1266 5.3406 13.311 5.1742Z",
    fill: "#2E84FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81958 6.004C8.40552 6.2751 9.03052 6.429 9.68208 6.46024V4.18124C9.48677 4.1914 9.2938 4.21015 9.10708 4.23827C8.59458 4.76561 8.16176 5.35859 7.81958 6.00389V6.004Z",
    fill: "#2E84FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.42183 15.8C9.50542 15.8078 9.59214 15.8141 9.68199 15.8187V13.5375C9.10153 13.5665 8.5398 13.6915 8.00854 13.911C8.39214 14.5969 8.86637 15.2313 9.42183 15.8V15.8Z",
    fill: "#2E84FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.98198 6.2758C6.67182 6.08595 6.37808 5.86564 6.1062 5.6172C4.90776 6.65314 4.18276 8.1196 4.0968 9.682H6.275C6.28047 8.48434 6.51796 7.3398 6.98204 6.2758H6.98198Z",
    fill: "#2E84FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.03817 4.5008C7.53427 4.6758 7.05849 4.9172 6.61707 5.2219C6.81941 5.39925 7.03503 5.5594 7.26083 5.70158C7.48427 5.28048 7.74443 4.87892 8.03817 4.5008Z",
    fill: "#2E84FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61646 14.7774C7.15786 15.1501 7.76489 15.4336 8.40005 15.6102C8.03755 15.1665 7.71411 14.6907 7.43755 14.1907C7.14693 14.3571 6.87194 14.554 6.61646 14.7774Z",
    fill: "#2E84FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29465 10.318H4.09705C4.18298 11.8805 4.90799 13.3462 6.10565 14.382C6.42597 14.089 6.77519 13.8359 7.14627 13.6258C6.65565 12.5797 6.36971 11.4688 6.29471 10.318L6.29465 10.318Z",
    fill: "#2E84FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0914 10.318H10.318V12.9078C11.0024 12.9531 11.6618 13.118 12.2821 13.3984C12.7453 12.425 13.0172 11.3898 13.0914 10.318L13.0914 10.318Z",
    fill: "#2E84FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.829 5.5624C13.5744 5.80146 13.2994 6.01708 13.0079 6.20458C13.4939 7.28974 13.7423 8.45858 13.7478 9.68278H15.9032C15.8149 8.08824 15.0665 6.60158 13.829 5.56238L13.829 5.5624Z",
    fill: "#2E84FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9205 4.2438C10.7236 4.21333 10.5212 4.19224 10.3181 4.18208V6.45388C10.972 6.40623 11.5947 6.23592 12.1752 5.94842C11.8392 5.32888 11.4181 4.75546 10.9205 4.24374L10.9205 4.2438Z",
    fill: "#2E84FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.4774 0 0 4.4774 0 10C0 15.5226 4.4774 20 10 20C15.5226 20 20 15.5226 20 10C20 4.4774 15.5226 0 10 0ZM10 16.464C6.389 16.464 3.4508 13.5648 3.4508 10C3.4508 6.4352 6.389 3.536 10 3.536C13.6118 3.536 16.5492 6.436 16.5492 10C16.5492 13.564 13.6116 16.464 10 16.464Z",
    fill: "#2E84FF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8446 13.6938C13.1977 13.9047 13.5282 14.154 13.8298 14.4368C15.0673 13.3977 15.8157 11.911 15.9032 10.318H13.729C13.6524 11.4945 13.3555 12.6282 12.8446 13.6938L12.8446 13.6938Z",
    fill: "#2E84FF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.629 15.604C12.2275 15.4353 12.7915 15.1743 13.3111 14.8259C13.0743 14.6126 12.8189 14.4228 12.5493 14.2587C12.2829 14.7298 11.9751 15.1806 11.629 15.604V15.604Z",
    fill: "#2E84FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.318 13.5454V15.8188C10.4149 15.8141 10.511 15.8071 10.6047 15.7977C11.1461 15.243 11.6102 14.6266 11.9875 13.9633C11.4586 13.7282 10.8985 13.5875 10.318 13.5454V13.5454Z",
    fill: "#2E84FF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4532 6.5204C11.7852 6.85008 11.0688 7.04228 10.318 7.09072V9.68212H13.1126C13.1071 8.56962 12.886 7.50712 12.4532 6.52032L12.4532 6.5204Z",
    fill: "#2E84FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetAccess);
export default __webpack_public_path__ + "static/media/internet-access.3d259c34906ecf25071848b9b9c66d58.svg";
export { ForwardRef as ReactComponent };